import { ValueAddServiceComponent } from './value-add-service.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ValueAddServiceRoutingModule } from './value-add-service-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SchemeReturnsComponent } from './scheme-returns/scheme-returns.component';
import { SchemeNavComponent } from './scheme-nav/scheme-nav.component';
import { SchemeDividendComponent } from './scheme-dividend/scheme-dividend.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown-angular7';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgOtpInputModule } from 'ng-otp-input';
import { BrandingComponent } from './branding/branding.component';
import { FormsComponent } from './forms/forms.component';
import { SchemePerformanceLumpsumComponent } from './scheme-performance-lumpsum/scheme-performance-lumpsum.component';
import { InvoicegenerateComponent } from './invoicegenerate/invoicegenerate.component';
import { SchemePerformanceCompareComponent } from './scheme-performance-compare/scheme-performance-compare.component';
import { TopSchemeSubAssetwiseComponent } from './top-scheme-sub-assetwise/top-scheme-sub-assetwise.component';
import { ScheduleclientComponent } from './scheduleclient/scheduleclient.component';
import { FocusedfundComponent } from './focusedfund/focusedfund.component';
import { DataUploadStatusComponent } from './data-upload-status/data-upload-status.component';

@NgModule({
  declarations: [
    SchemeReturnsComponent,
    SchemeNavComponent,
    SchemeDividendComponent,
    ValueAddServiceComponent,
    BrandingComponent,
    FormsComponent,
    SchemePerformanceLumpsumComponent,
    //  SearchPipe,
    InvoicegenerateComponent,
    SchemePerformanceCompareComponent,
    TopSchemeSubAssetwiseComponent,
    ScheduleclientComponent,
    FocusedfundComponent,
    DataUploadStatusComponent
  ],
  imports: [
    CommonModule,
    ValueAddServiceRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgMultiSelectDropDownModule.forRoot(),
    SharedModule,
    TooltipModule,
    NgOtpInputModule
  ]
})
export class ValueAddServiceModule {}
